import {getCookie} from "./cookie-typescript-utils";

export default function authHeader() {
  var cookie = getCookie('PAYMENT_SESSION');
    return { Authorization: 'Bearer ' + cookie }; // for Spring Boot back-end
}
